import { Component } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { SurveyService } from '../../Services/survey.service';
import { Router } from '@angular/router';

@Component({
    selector: 'survey-create',
    templateUrl: './survey-create.component.html',
    styleUrls: ['./survey-create.component.scss']
})

export class SurveyCreateComponent {
    StartDate: Date; EndDate: Date;
    minDate: Date = new Date();

    constructor(
        private _shared: SharedService, private _survey: SurveyService,
        private _router: Router
    ) {
        // Setting up page title
        this._shared.pageTitle = 'Create new survey';
    }

    onSubmit(form) {
        if (form.valid) {
            form.value['CreatedBy'] = 1; // User id.
            form.value['StartDate'] = this.StartDate.toISOString().split('T')[0];
            form.value['EndDate'] = this.EndDate.toISOString().split('T')[0];
            form.value['PublishedDate'] = (new Date()).toISOString().split('T')[0];
            this._survey.createNewSurvey(form.value).subscribe(res => {
                this._router.navigate([`/dashboard/survey/edit/${res.SurveyID}`]);
            });
        }
    }
}